import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';

import { StepNavigatorButtons } from 'components/OverviewFlow/StepNavigatorButtons';
import { ConsentPageWrapper, SectionHeader, List } from './styles';
import BulletIcon from 'images/overview/bullet.svg';
import { updateOverviewStep } from 'store/overview';

function Consent (props) {
  const dispatch = useDispatch();
  const { onForward, onBack } = props;

  useEffect(() => {
    dispatch(updateOverviewStep('Consent'));
  }, []);

  return (
    <ConsentPageWrapper>
      <SectionHeader>
        <Typography
          variant='pb3' color='primary.gray8' fontFamily='Montserrat'>
          Information about the ADPKD Patient Registry:
        </Typography>
      </SectionHeader>
      <div>
        <Typography
          variant='pl3' color='primary.gray8' fontFamily='Montserrat'>
          A patient registry is a database that collects health information of
          people with a specific disease or condition. In addition, a Registry
          keeps information in one place making it easier for researchers to
          utilize medical information while still protecting the privacy of
          those who take part. The ADPKD Patient Registry will collect data most
          relevant to your ADPKD diagnosis, its major symptoms and management,
          as well as key demographic data (no personally identifiable
          information is shared without your permission).
        </Typography>
      </div>
      <SectionHeader>
        <Typography
          variant='pb3' color='primary.gray8' fontFamily='Montserrat'>
          Purpose and Goals of the PKD registry:
        </Typography>
      </SectionHeader>
      <List>
        <li>
          <img
            src={BulletIcon} alt='bullet-icon'
          />
          Supporting research to find treatments and a cure for PKD.
        </li>
        <li>
          <img
            src={BulletIcon} alt='bullet-icon'
          />
          Supporting the development of new medications and treatments for the
          ADPKD disease.
        </li>
        <li>
          <img
            src={BulletIcon} alt='bullet-icon'
          />
          Engaging with patients by measuring quality of life outcomes and
          collecting information to better describe the ADPKD disease
          experience.
        </li>
      </List>
      <StepNavigatorButtons
        onForward={onForward} onBack={onBack}
      />
    </ConsentPageWrapper>
  );
}

export default Consent;
